import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { useItemWorkflowTableStore } from '@/warehouse/components/ItemWorkflowTable/business';
import { workflowItemProcessedSnackbarDuration } from '@/warehouse/constants';
import { getReceiptItemAvailableQuantity } from '@/warehouse/helpers';
import { playWarehouseSound } from '@/warehouse/hooks';
import { crossdockReceiptActions } from '../crossdockReceipt.state';
const tryBlockReceiptItem = (receiptItem) => (dispatch) => {
    if (!receiptItem) {
        const { searchTerm, setSearchTerm } = useItemWorkflowTableStore.getState();
        if (searchTerm.trim().length === 0)
            return;
        // A single snackbar is allowed at one moment. Manually closing the existed one.
        closeSnackbar();
        playWarehouseSound('error');
        enqueueSnackbar({
            key: searchTerm,
            preventDuplicate: true,
            variant: 'receiptSubmissionError',
            article: searchTerm,
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            autoHideDuration: workflowItemProcessedSnackbarDuration,
        });
        setSearchTerm('');
        return;
    }
    const availableQuantity = getReceiptItemAvailableQuantity(receiptItem);
    if (availableQuantity < 1) {
        playWarehouseSound('full');
        return;
    }
    dispatch(crossdockReceiptActions.openBlockReceiptItemDialog(receiptItem));
};
export { tryBlockReceiptItem };
